import { useState, useEffect } from 'react'
import { Modal, ModalHeader, ModalBody, Container, Row, Col } from 'reactstrap'
import s from './CreateDealModal.scss'
import { FaAngleRight, FaAngleDown } from 'react-icons/fa'
import { Checkbox } from 'components/ideal-core-ui'
import { useImmer } from 'use-immer'
import { DealModalContent } from 'components/Deals/DealsModal/DealModalContent'
import { useSelector } from 'react-redux'
import { toUsers } from './serializers'
import { makeGetRequest } from 'utils/api'

const CreateDealModal = ({ toggleCreateDealModal, isCreateDealModalOpen, lead, createDeal }) => {
  const [isInfoSectionOpen, setIsInfoSectionOpen] = useState(true)
  const [isCreateDealSectionOpen, setIsCreateDealSectionOpen] = useState(true)
  const [prevLead, setPrevLead] = useState(lead)
  const [localLead, setLocalLead] = useImmer(lead)
  const [shouldCopyNotes, setShouldCopyNotes] = useState(true)
  const [shouldCopyChecklist, setShouldCopyChecklist] = useState(true)
  const storedUsers = useSelector(state => state.users.users)
  const [users, setUsers] = useState(toUsers(storedUsers) || [])

  if (prevLead !== lead) {
    setPrevLead(lead)
    setLocalLead(lead)
  }

  useEffect(() => {
    ;(async () => {
      if (users.length) return
      const { content } = await makeGetRequest('/v1/users')
      setUsers(toUsers(content))
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <Modal
        keyboard={false}
        backdrop="static"
        isOpen={isCreateDealModalOpen}
        toggle={toggleCreateDealModal}
        size="xl"
      >
        <ModalHeader toggle={toggleCreateDealModal} className={s.modalHeader}>
          Create Opportunity from Lead
        </ModalHeader>
        <ModalBody>
          <Container>
            <p>
              {!isInfoSectionOpen ? (
                <FaAngleRight
                  style={{ cursor: 'pointer' }}
                  onClick={() => setIsInfoSectionOpen(!isInfoSectionOpen)}
                />
              ) : (
                <FaAngleDown
                  style={{ cursor: 'pointer' }}
                  onClick={() => setIsInfoSectionOpen(!isInfoSectionOpen)}
                />
              )}{' '}
              <span className={s.category}>Lead Information</span>
            </p>
            {isInfoSectionOpen && (
              <Row style={{ marginBottom: 30 }}>
                <Col>
                  <div className={s.leadInfo}>
                    <p>
                      <span className={s.leadInfoLabel}>Name:</span>
                      <span className={s.leadInfoValue}>{lead.name}</span>
                    </p>
                    <p>
                      <span className={s.leadInfoLabel}>First:</span>
                      <span className={s.leadInfoValue}>{lead.contactFirstName}</span>
                    </p>
                    <p>
                      <span className={s.leadInfoLabel}>Last:</span>
                      <span className={s.leadInfoValue}>{lead.contactLastName}</span>
                    </p>
                    <p>
                      <span className={s.leadInfoLabel}>Email:</span>
                      <span className={s.leadInfoValue}>{lead.email}</span>
                    </p>
                    <p>
                      <span className={s.leadInfoLabel}>Phone:</span>
                      <span className={s.leadInfoValue}>{lead.phone}</span>
                    </p>
                    <p>
                      <span className={s.leadInfoLabel}>Title:</span>
                      <span className={s.leadInfoValue}>{lead.title}</span>
                    </p>
                    <p>
                      <span className={s.leadInfoLabel}>Company:</span>
                      <span className={s.leadInfoValue}>{lead.company}</span>
                    </p>
                  </div>
                </Col>
                <Col>
                  <div className={s.leadInfo}>
                    <div>
                      <span className={s.leadInfoLabel}>Address</span>
                      <p className={s.leadInfoValue}>{lead.address}</p>
                      <p className={s.leadInfoValue}>{lead.address2}</p>
                    </div>
                  </div>
                </Col>
                <div className={s.aboutInfo}>
                  <p>
                    <span className={s.leadInfoLabel}>About:</span>
                    <span className={s.leadInfoValue}>{lead.about}</span>
                  </p>
                </div>
              </Row>
            )}
            <p>
              {!isCreateDealSectionOpen ? (
                <FaAngleRight
                  style={{ cursor: 'pointer' }}
                  onClick={() => setIsCreateDealSectionOpen(!isCreateDealSectionOpen)}
                />
              ) : (
                <FaAngleDown
                  style={{ cursor: 'pointer' }}
                  onClick={() => setIsCreateDealSectionOpen(!isCreateDealSectionOpen)}
                />
              )}{' '}
              <span className={s.category}>Create Opportunity from Lead</span>
            </p>
            {isCreateDealSectionOpen && (
              <>
                <DealModalContent
                  createDeal={(deal, cb) => {
                    createDeal(deal, cb, { shouldCopyChecklist, shouldCopyNotes })
                  }}
                  users={users}
                  lead={{
                    name: localLead.name,
                    address: {
                      address: localLead.address,
                      address2: localLead.address2,
                      city: localLead.city,
                      region: localLead.region,
                      zipCode: localLead.zipCode,
                      country: localLead.country
                    }
                  }}
                />
                <div className={s.checkboxWrapper}>
                  <Checkbox
                    isChecked={shouldCopyNotes}
                    triggerCheckbox={value => setShouldCopyNotes(value.target.checked)}
                  />
                  <p>Copy Lead Notes to Opportunity Notes</p>
                  <br />
                  <Checkbox
                    isChecked={shouldCopyChecklist}
                    triggerCheckbox={value => setShouldCopyChecklist(value.target.checked)}
                  />
                  <p>Copy Lead Checklists to Opportunity Checklists</p>
                </div>
              </>
            )}
          </Container>
        </ModalBody>
      </Modal>
    </>
  )
}

export default CreateDealModal
